import styled from 'styled-components'
import { Link } from 'gatsby'
import { sizeMobile, gutter } from 'components/globalStyles'
import { LinkButton } from 'components/common/typography'

export const MainContainer = styled.nav`
  width: 100%;
  height: 64px;
  background: ${props => (props.isScrolled ? 'white' : 'linear-gradient(180deg, rgba(27, 22, 22, 0.6) 0%, rgba(27, 22, 22, 0) 100%)')};
  color: ${props => (props.isScrolled ? 'var(--spBlack)' : 'white')};
  position: fixed;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: ${gutter};
`

export const LogoLink = styled(Link)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: ${props => (props.$home ? 'none' : 'inherit')};

  @media (max-width: ${sizeMobile}) {
    display: none;
  }
`

export const AccountLink = styled(Link)`
  display: flex;
  text-decoration: none;
  color: ${props => (props.$isScrolled ? 'var(--spBlack)' : 'white')};
  font-family: Garamond;
  gap: 8px;
  align-items: center;

  & svg {
    flex: none;
  }

  & div {
    color: ${props => (props.$isScrolled ? 'var(--spBlack)' : 'white')};
  }
`

export const MenuContainer = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  z-index: 101;
  padding: 0 24px 32px 32px;
  background: white;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: start;

  & ul {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  & h3 {
    position: relative;
  }

  & h4 {
    margin-left: 16px;
  }

  & a {
    text-decoration: none;
  }

  & button {
    color: var(--spBlack);
  }
`

export const MenuHeader = styled.div`
  width: 100%;
  height: 88px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 36px;
  position: sticky;
  background: white;
  top: 0;
  z-index: 1;
  flex: none;
`

export const Arrow = styled.div`
  display: inline-block;
  font-size: 0.6em;
  margin-left: 12px;
  transform: translateY(-2px);
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-top: 88px;
  margin-top: auto;
`

export const BookButton = styled(LinkButton)`
  font-size: 1.8rem;
  border: none;
  background: ${props => (props.$isScrolled ? 'var(--spBlack)' : 'white')};
  color: ${props => (props.$isScrolled ? 'white' : 'var(--spBlack)')};
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 1.5rem;
  transition: none;
  width: fit-content;

  &:hover {
    background: ${props => (props.$isScrolled ? 'white' : 'var(--spBlack)')};
    color: ${props => (props.$isScrolled ? 'var(--spBlack)' : 'white')};
    transition: all 0.4s;
  }
`
